import { useEffect, useState } from "react";
import { useBlockUI } from "../../../shared/services/block-ui-service";
import instance from "../../index";
import { BaseResponse } from "../../../models/base-response";
import { PagedList } from "../../../models/paged-list";
import { ShortDto } from "../../../models/short-dto";
import {
    CreateOperationTypeRequest,
    UpdateOperationTypeRequest
} from "../../../models/requests/create-operation-type-request";
import {OperationTypeFilter} from "../../../filters/operation-type-filter";
import {OperationType} from "../../../models/fleet-type";

const useOperationTypeService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();

    useEffect(() => {
        blockUI?.setActive(loading);
    }, [loading]);

    async function createOperationType(request: Partial<CreateOperationTypeRequest>) {
        const response = await instance.post("/v1/backoffice/operation-types", request);
        return response.data;
    }

    async function activateOperationType(id: string) {
        const response = await instance.put(`/v1/backoffice/operation-types/${id}/activate`);
        return response.data;
    }

    async function deactivateOperationType(id: string) {
        const response = await instance.put(`/v1/backoffice/operation-types/${id}/deactivate`);
        return response.data;
    }

    async function getOperationTypes(filter?: OperationTypeFilter): Promise<PagedList<OperationType>> {
        const response = await instance.get<BaseResponse<PagedList<OperationType>>>("/v1/backoffice/operation-types", { params: filter });
        return response?.data?.data;
    }

    async function getOperationTypeById(id: string) {
        const response = await instance.get<BaseResponse<OperationType>>(`/v1/backoffice/operation-types/${id}`);
        return response?.data?.data;
    }

    async function updateOperationType(id: string, request: Partial<UpdateOperationTypeRequest>) {
        const response = await instance.put(`/v1/backoffice/operation-types/${id}`, request);
        return response.data;
    }

    async function deleteOperationType(id: string) {
        const response = await instance.delete(`/v1/backoffice/operation-types/${id}`);
        return response?.data;
    }

    async function getOperationTypesShort(): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>("/v1/backoffice/operation-types/short");
        return response?.data?.data;
    }

    return {
        loading,
        createOperationType,
        activateOperationType,
        deactivateOperationType,
        getOperationTypes,
        getOperationTypeById,
        updateOperationType,
        deleteOperationType,
        getOperationTypesShort
    };
};

export default useOperationTypeService;
